import { render } from "./View2D.vue?vue&type=template&id=0abb7ece"
import script from "./View2D.vue?vue&type=script&lang=js"
export * from "./View2D.vue?vue&type=script&lang=js"

import "./View2D.vue?vue&type=style&index=0&id=0abb7ece&lang=css"
script.render = render

export default script